import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { injectIntl, FormattedMessage, FormattedDate } from 'react-intl'
import moment from 'moment'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import { formValueSelector, reduxForm, initialize, destroy } from 'redux-form'
import { IMPERIAL } from 'shared/units/constants'
import CharField from 'components/forms/CharField/CharField'
import SelectField from 'components/forms/SelectField'
import Button from 'components/util/Button'
import Loader from 'components/util/Loader'
import { constructSelectOptions } from './messages'
import validate from './validate'
import styles from './_createGoalForm.css'
import GoalDescription from './GoalDescription'
import { GOAL_TYPES, GOAL_ACTIVITY } from '../shared/constants'

export const FORM_NAME = 'createGoal'
const formSelector = formValueSelector(FORM_NAME)

const formOptions = {
  form: FORM_NAME,
  validate,
}

const mapStateToProps = (state) => ({
  goalType: formSelector(state, 'type'),
  activity: formSelector(state, 'activity'),
  target: formSelector(state, 'target'),
  startTime: formSelector(state, 'startTime'),
})

const mapDispatchToActions = {
  initialize,
  destroy,
}

export class CreateGoalForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    isLoading: PropTypes.bool,
    dispatch: PropTypes.func,
    system: PropTypes.string,
    goalType: PropTypes.string,
    activity: PropTypes.string,
    target: PropTypes.string,
    startTime: PropTypes.string,
    paramGoalType: PropTypes.string,
    paramTarget: PropTypes.string,
    intl: PropTypes.object,
    initialize: PropTypes.func,
  }

  state = {
    selectOptions: constructSelectOptions(this.props.intl),
  }

  componentDidMount () {
    const {
      paramGoalType,
      paramTarget,
    } = this.props

    const initialGoalType = paramGoalType || GOAL_TYPES.workouts.key
    const initialTarget = paramTarget || '1'

    this.props.initialize({
      activity: '',
      type: initialGoalType,
      target: initialTarget,
      startTime: 'nextweek',
    })
  }

  render () {
    const {
      handleSubmit,
      system,
      isLoading,
      goalType,
      activity,
      target,
      startTime,
    } = this.props

    const { selectOptions } = this.state

    let targetUnit = ''

    if (goalType === GOAL_TYPES.duration.key) {
      targetUnit = '(hr)'
    } else if (goalType === GOAL_TYPES.distance.key) {
      targetUnit = system === IMPERIAL ? '(mi)' : '(km)'
    }

    let startDate = moment().startOf('week').toDate()

    if (startTime === 'nextweek') {
      startDate = moment().endOf('week').add(1, 'd').toDate()
    }

    const verbLabel = GOAL_ACTIVITY[activity] || <FormattedMessage id='create.goal.complete' defaultMessage='Complete ' />

    return (
      <div className={styles.createGoalFormContainer}>
        <form onSubmit={handleSubmit}>
          <Row>
            <Col xs={12} sm={8}>
              <SelectField
                name='activity'
                options={selectOptions.activityType}
                labelComponent={(
                  <FormattedMessage
                    id='create.goal.activity'
                    defaultMessage='Activity' />
                )}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={8}>
              <SelectField
                name='type'
                options={selectOptions.goals}
                labelComponent={(
                  <FormattedMessage
                    id='create.goal.type'
                    defaultMessage='Goal Type' />
                )}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={8}>
              <CharField
                name='target'
                required={true}
                labelComponent={(
                  <FormattedMessage
                    id='create.goal.target'
                    defaultMessage='Goal Target {unit}'
                    values={{
                      unit: targetUnit,
                    }} />
                )}
                errorComponent={(
                  <FormattedMessage
                    id='create.goal.target.error'
                    defaultMessage='Goal target is required' />
                )}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={8}>
              <SelectField
                name='startTime'
                options={selectOptions.startTime}
                labelComponent={(
                  <FormattedMessage
                    id='create.goal.start'
                    defaultMessage='Start' />
                )}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className={styles.goalDescription}>
              {verbLabel}
              <FormattedMessage
                id='goalcreate.desc'
                defaultMessage='{goal} starting on {startDate}'
                values={{
                  goal: <GoalDescription value={target} goalType={goalType} system={system} />,
                  startDate: <FormattedDate value={startDate} />,
                }} />
            </Col>
          </Row>
          {isLoading ?
            <Loader type='spin' height={45} width={45} />
          :
            <Button
              el='button'
              type='action'
              size='large'>
              <FormattedMessage id='creategoal.submit' defaultMessage='Create Goal' />
            </Button>}
        </form>
      </div>
    )
  }
}

export const IntlPage = injectIntl(CreateGoalForm)
export const Form = reduxForm(formOptions)(IntlPage)
export default connect(mapStateToProps, mapDispatchToActions, null, { withRef: false })(Form)



// WEBPACK FOOTER //
// ./src/components/goals/create/CreateGoalForm.jsx